import { attr, customElement, DOM, FASTElement, observable } from '@microsoft/fast-element';
import { CancelModalTemplate as template } from './cancel-modal.template';
import { CancelModalStyles as styles } from './cancel-modal.styles';
import { RightSideModal } from '../../right-side-modal/right-side-modal';
import { INegotiationService, IRfqService } from "../../../services";
import { ButtonAppearance, notifyError } from "../../../utils/notify";
import {
  ToastButton,
} from '@genesislcap/foundation-notifications';
import { INotificationService } from "../../../services/notification.service";
import {CONTRACT_TYPE, NEGOTIATION_STATUS} from "../../../utils";
import {IThirdPartyService} from "../../../services/third-party.service";

const name = 'cancel-modal';
@customElement({
  name,
  template,
  styles,
})
export class CancelModal extends FASTElement {
  @attr show: boolean = false;
  @observable width: string = '375px';
  @observable cancelModal: RightSideModal;
  @observable id: string;
  @observable objectType: string;
  @observable description: string;

  @INegotiationService negotiationService: INegotiationService;
  @INotificationService notificationService: INotificationService;
  @IRfqService rfqService: IRfqService;
  @IThirdPartyService thirdPartyService: IThirdPartyService;

  structuredChatNegotiationStatuses = [NEGOTIATION_STATUS.IN_PROGRESS, NEGOTIATION_STATUS.REQUIRES_CONFIRMATION, NEGOTIATION_STATUS.CONFIRMED_AWAITING_BUYER, NEGOTIATION_STATUS.CONFIRMED_AWAITING_SELLER, NEGOTIATION_STATUS.SUCCESSFUL];

  objectToDelete: object;

  constructor() {
    super();
    this.thirdPartyService.loadArteriaUrl();
  }

  public async openModal(objectToDelete: any, objectType: string, description: string) {
    if(objectToDelete.CONTRACT_TYPE === CONTRACT_TYPE.MINI_POST_BUILD_VPPA_AUTO_EXECUTED ) {
      this.show = true;
      this.objectType = objectType;
      this.objectToDelete = objectToDelete;
      this.description = description;
      return;
    }
    let params: any = null
    let ticker = ''
    let uniqueId = ''
    let contractType = ''
    if(objectToDelete) {
      if(objectType === 'VPPA') {
        ticker = objectToDelete.TICKER
        uniqueId = objectToDelete.UNIQUE_ID
        contractType = objectToDelete.CONTRACT_TYPE
        params = {
          VPPA_ID: objectToDelete.VPPA_ID
        }
      } else if(objectType === 'RFQ') {
        ticker = objectToDelete.TICKER
        uniqueId = objectToDelete.UNIQUE_ID
        contractType = 'RFQ'
        params = {
          RFQ_ID: objectToDelete.RFQ_ID
        }
      }
    }
    if(params) {
      this.negotiationService.getNegotiation(params).then((result) => {
        if(result.REPLY && result.REPLY.every(negotiation => negotiation.NEGOTIATION_STATUS == NEGOTIATION_STATUS.REJECTED || negotiation.NEGOTIATION_STATUS == NEGOTIATION_STATUS.FULL_DELETED)) {
          this.show = true;
          this.objectType = objectType;
          this.objectToDelete = objectToDelete;
          this.description = description;
        } else {
          //notification if a negotiation is in structured chat
          if(result.REPLY.some(negotiation => this.structuredChatNegotiationStatuses.includes(negotiation.NEGOTIATION_STATUS))) {
            let actions: ToastButton[] = [{
              condition: () => {
                return true
              },
              action: ({ details, toastElement }) => {
                toastElement.close();
                this.notificationService.openStructuredChat(result.REPLY[0].NEGOTIATION_ID)
              },
              placeholder: 'View Chat',
              appearance: ButtonAppearance.PRIMARY,
            }]
            notifyError(`${ticker} ${uniqueId} Was not deleted`, `Your ${contractType} could not be deleted because it is currently engaged in chat with another party`, '', 10000, actions);
          }
          //notification if a negotiation is passed structured chat
          if(result.REPLY.some(negotiation => !this.structuredChatNegotiationStatuses.includes(negotiation.NEGOTIATION_STATUS))) {
            let actions: ToastButton[] = [{
              condition: () => {
                return true
              },
              action: ({ details, toastElement }) => {
                toastElement.close();
                this.thirdPartyService.openArteriaNegotiations();
              },
              placeholder: 'Negotiation',
              appearance: ButtonAppearance.PRIMARY,
            }]
            notifyError(`${ticker} ${uniqueId} Was not deleted`, `Your ${contractType} could not be deleted because negotiations are currently active. Please proceed to the Negotiations tab to cease negotiations with the Counter Party`, '', 10000, actions);
          }
        }
      });
    }
  }

  public submitCancellation() {
    this.$emit('confirmCancel', this.objectToDelete);
  }

  closeDialog() {
    this.show = false;
  }
}
